/**
 * Whether an edit empties a nullable masked field (PD-13793, PD-16171), so
 * the field reads its placeholder and reports "no value" rather than 0.
 *
 * - Every digit gone, as after a select-all delete, empties it.
 * - So does a deletion that leaves only zeros. A formatted "$0.00" still
 *   holds "000" once the last real digit is backspaced, which would
 *   otherwise read as an entered 0 and could never be emptied by
 *   backspacing.
 * - Typing a 0 is an insertion, not a deletion, so a deliberate $0.00 is
 *   kept as a value.
 *
 * `inputType` is the browser's InputEvent.inputType ("insertText",
 * "deleteContentBackward", "deleteByCut", ...). When it is unknown, only an
 * edit that removes every digit counts.
 */
export function editEmptiesMaskedValue(
	newDigits: string,
	inputType: string | undefined,
): boolean {
	if (newDigits === '') {
		return true;
	}

	return (
		inputType != null &&
		inputType.startsWith('delete') &&
		/^0+$/.test(newDigits)
	);
}
